import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button } from '@mui/material';
import { useNotification } from 'components/Notification';
import { DomainStatsData } from 'pages/AdvertisersDashboard/types';
import React from 'react';
import { exportDataToCsv } from 'utils/data-exports';
import { downloadBlob } from 'utils/download';

interface ExportAllButtonProps {
  completeStats: DomainStatsData;
}

const ExportAllButton: React.FunctionComponent<ExportAllButtonProps> = (
  props,
) => {
  const { completeStats } = props;

  const { showError } = useNotification();

  const btnDisabled = completeStats.loading || completeStats.error;

  const handleExportButtonClick = React.useCallback(async () => {
    try {
      const blob = exportDataToCsv({
        columnsNames: [
          'Site',
          'App',
          'Bundle ID',
          'Platform',
          'Unique Engagement',
        ],
        data: completeStats.data,
        fieldsSelector: [
          'domain',
          'appDisplayName',
          'bundleId',
          'platform',
          'spEngaged',
        ],
      });
      await downloadBlob('top-performing-sites.csv', blob);
    } catch (err) {
      showError(`Failed to export the csv: ${String(err)}`);
    }
  }, [completeStats, showError]);

  return (
    <Button
      disabled={btnDisabled}
      onClick={handleExportButtonClick}
      startIcon={<FileDownloadIcon />}
      variant="outlined"
    >
      Export all
    </Button>
  );
};

export default ExportAllButton;
